import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    // Perform logout
    logout();

    // Redirect to sign-in page
    navigate("/authentication/sign-in");
  }, [logout, navigate]);

  return null;
}

export default Logout;
